<template>
  <div class="cta-container" v-if="hasResource">
    <div v-if="!isRegisteredForWebinar">
      <cta-button type="cta-button" class="cta-button" @click="openResourceModal" qa="resource-btn">{{ buttonText }}</cta-button>
    </div>
    <div v-else>
      <p class="has-text-centered pb-3">You are registered for this webinar.</p>
      <div v-if="isUpcoming">
        <cta-button type="cta-button" class="cta-button" @click="sendConfirmation" qa="resource-btn">Resend Invite</cta-button>
      </div>
      <p v-if="resentInvite" class="has-text-centered pt-3 pb-3 text-color">Please check your email for invitation</p>
    </div>
    <resource @hook:mounted="openWhenLoggedIn" :project="this.project" class="confirm-visibility" ref="resourceModal"></resource>
  </div>
</template>

<script>
import ctaButton from '@/components/Controls/ButtonTemplate'
import Resource from '@/components/Modals/Resource'
import i18n from '@/i18n'
import auth from '@/mixins/auth'
import resources from '@/mixins/resources'
import webinars from '@/api/webinars'

export default {
  mixins: [auth, resources],
  components: {
    ctaButton,
    Resource
  },
  props: ['project', 'fromBody'],
  data: function () {
    return {
      isLoggingIn: false,
      buttonClicked: false,
      resentInvite: false
    }
  },
  watch: {
    '$store.getters.isSignupComplete': function () {
      this.isLoggingIn = true
      this.openWhenLoggedIn()
    }
  },
  computed: {
    buttonText: function () {
      if (!this.isLoggedIn) {
        return i18n.t('resource.signUp')
      }

      if (this.resourceType === 'webinar' && this.isPastWebinar && this.compareWebinarDate) {
        return i18n.t('resource.watch')
      }

      return this.$store.getters.resourceButtonText
    },
    compareWebinarDate: function () {
      const convertWebinarDate = new Date(this.project.resource.webinar.webinar_date)
      const currentDate = new Date()
      return currentDate > convertWebinarDate
    },
    resourceButtonClicked: function () {
      return this.$store.getters.resourceButtonClicked
    },
    isRegisteredForWebinar: function () {
      return this.isLoggedIn && this.isWebinar && this.isRegistered
    }
  },
  mounted: function () {
    this.modals = [this.$refs.resourceModal]
  },
  methods: {
    openResourceModal: function () {
      if (!this.isLoggedIn) {
        this.$store.dispatch('resourceButtonClicked', true)
        this.$store.dispatch('showLoginModal', { source: 'resourcePage:' + this.project.id })
      } else {
        this.$refs.resourceModal.showModal()
      }
    },
    openWhenLoggedIn: async function () {
      if (this.isLoggingIn && this.project && this.$refs.resourceModal && !this.$refs.resourceModal.active && this.fromBody && this.resourceButtonClicked) {
        await this.$refs.resourceModal.fetchQuestions()
        this.$refs.resourceModal.showModal()
        this.isLoggingIn = false
        this.$store.dispatch('resourceButtonClicked', false)
      }
    },
    sendConfirmation: function () {
      webinars.sendConfirmationEmail({ webinar_id: this.project.resource.webinar.go_to_webinar_id }).then((following) => {
        this.resentInvite = true
      }, () => {
        this.resentInvite = false
      })
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .cta-container {
    margin: auto 0;
    width: 100%;
    padding: 10px;
  }
  .cta-button {
    margin: 0 auto;
    display: block;
  }
  .text-color {
    color: #f14668;
  }
</style>
